import React from "react"
import { PropTypes } from "prop-types"
import { beeswarm } from "d3-beeswarm"

import { Box, Tooltip } from "../../../ui"

const Chart = ({
  data,
  symbol,
  symbolSize = 24,
  width,
  height,
  scale,
  tooltipFormat,
  side,
  radius,
  selected,
  keyValue,
  top,
}) => {
  if (!width) return null

  scale.range([0, width])

  const swarm = beeswarm()
    .data(data)
    .distributeOn(d => scale(d[keyValue]))
    .radius(radius)
    .orientation("horizontal")
    .side(side)
    .arrange()

  const getOpacity = ({ datum: { id } }) =>
    !selected.length ? 1 : selected.indexOf(id) !== -1 ? 1 : 0.15

  const symbolTransform = d => {
    const x = d.x - symbolSize / 2
    let y = top + d.y - symbolSize / 2

    // place symbols above the line if negative
    if (side === "negative") y -= symbolSize / 2
    // place symbols below the line if negative
    if (side === "positive") y += symbolSize / 2

    return `translate(${x}px,${y}px)`
  }

  return (
    <Box>
      <Box style={{ height }}>
        {swarm.map(d => {
          const symbolComponent = symbol ? (
            <span>{symbol(d.datum)}</span>
          ) : (
            <Box
              borderRadius="full"
              bg="gray.500"
              w={`${symbolSize}px`}
              h={`${symbolSize}px`}
            />
          )

          return (
            <Box
              key={d.datum.id}
              position="absolute"
              left={0}
              w={`${symbolSize}px`}
              h={`${symbolSize}px`}
              transform={symbolTransform(d)}
              opacity={getOpacity(d)}
              transition="all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)"
            >
              {tooltipFormat ? (
                <Tooltip label={tooltipFormat(d.datum)} placement="top">
                  {symbolComponent}
                </Tooltip>
              ) : (
                symbolComponent
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

Chart.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  symbol: PropTypes.func,
  symbolSize: PropTypes.number,
  domain: PropTypes.array,
  tooltipFormat: PropTypes.func,
  tooltipOffset: PropTypes.array,
  radius: PropTypes.number,
  side: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  keyValue: PropTypes.string,
  scale: PropTypes.func,
  top: PropTypes.number,
}

export default Chart
